const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const LINKEDIN_PATTERN = /^https?:\/\/([a-z]{2,3}\.)?linkedin\.com\/(in|pub)\/[A-Za-z0-9\-_%]+\/?$/i;

const ACCEPTED_CV_EXTENSIONS = ['pdf', 'doc', 'docx'];
export const MAX_CV_BYTES = 5 * 1024 * 1024;

export function isBlank(value: string): boolean {
  return value.trim().length === 0;
}

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function isValidLinkedInUrl(value: string): boolean {
  return LINKEDIN_PATTERN.test(value.trim());
}

export function validateCvFile(file: File | null): string | undefined {
  if (!file) return undefined;
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (!ACCEPTED_CV_EXTENSIONS.includes(extension)) {
    return 'Please choose a PDF, DOC or DOCX file.';
  }
  if (file.size > MAX_CV_BYTES) {
    return 'Please choose a file smaller than 5 MB.';
  }
  return undefined;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
